<template>
  <div>
    <div
      class="row"
      v-for="(rowInput, rowIndex) of listRowInput"
      :key="'row' + rowIndex"
    >
      <div
        v-for="(item, index) of rowInput"
        :key="item.model + rowIndex + index"
        :class="getClassList(item.itemPerRow)"
      >
        <template v-if="item.type === FORM_TYPE.ARRAY_OBJECT">
          <template v-if="!isNaN(modelData[item.size])">
            <template v-for="childRowIndex in Number(modelData[item.size])">
              <DetailSectionRowLayout
                :key="'childRowIndex-' + childRowIndex"
                :modelData="modelData[item.model][childRowIndex - 1]"
                labelKey="labelDetail"
                :listFields="item.items"
              />
            </template>
          </template>
        </template>
        <template v-else-if="item.type === FORM_TYPE.SLOT">
          <slot :name="item.name"></slot>
        </template>
        <template v-else>
          <div v-if="isDisplayItem(item)">
            <label>{{ getDisplayLabel(item) }}</label>
            <p class="detail-info">{{ getDisplayValue(item, item.model) }}</p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
/* This component is used to detail information of fields by rows*/
import { FORM_TYPE } from "../../constants/custom-define-type";

export default {
  name: "DetailSectionRowLayout",
  props: {
    listFields: {
      type: Array,
      default: () => []
    },
    modelData: Object,
    labelKey: {
      type: String,
      default: "label"
    },
    listExcludeFields: {
      type: Array,
      default: () => []
    }
  },
  data: function() {
    return {
      FORM_TYPE: FORM_TYPE
    };
  },
  computed: {
    listRowInput() {
      return this.listFields.reduce((accResult, cur) => {
        if (accResult.length === 0) {
          return [[cur]];
        }
        if (cur.itemPerRow == null || cur.itemPerRow === 1) {
          return [...accResult, [cur]];
        }
        const lastEl = accResult[accResult.length - 1];
        const numberOfitemPerRow = lastEl[0].itemPerRow
          ? lastEl[0].itemPerRow
          : 1;
        if (numberOfitemPerRow === lastEl.length) {
          return [...accResult, [cur]];
        }
        accResult[accResult.length - 1].push(cur);
        return accResult;
      }, []);
    }
  },
  methods: {
    getClassList(itemPerRow) {
      if (itemPerRow == null || itemPerRow === 1) {
        return "col-lg-12";
      }
      return "col-lg-" + String(12 / itemPerRow);
    },
    isDisplayItem(item) {
      if (this.listExcludeFields.includes(item.model)) {
        return false;
      }
      if (item.model == null) {
        return false;
      }
      if (!this.isItemShow(this.modelData, item)) {
        return false;
      }
      if (this.isMissingField(this.modelData, item.model, item.type)) {
        return false;
      }
      if (item.keyNotNull) {
        if (this.modelData[item.keyNotNull] == null) {
          return false;
        }
      }
      if (item.keyNull) {
        if (this.modelData[item.keyNull] != null) {
          return false;
        }
      }
      return true;
    },
    getDisplayValue(item, key) {
      const value = this.getValueOfObjectKey(this.modelData, key);
      if (item.type === FORM_TYPE.DAY_HOURS_SELECTOR) {
        if (value == null || value.length === 0) {
          return "";
        }
        const listWorkingDays = this.$store.getters.workingDays;
        let result = "";
        for (let index = 0; index < listWorkingDays.length; index++) {
          if (value[index] == null || value[index].length === 0) {
            continue;
          }
          result =
            result +
            "\n" +
            listWorkingDays[index] +
            ": From " +
            value[index].replace(",", " To ");
        }
        return result.trim();
      }
      if (item.type === FORM_TYPE.SALARY_RANGE) {
        if (value == null || value.length < 3) {
          return "";
        }
        return "From: $" + value[0] + " To: $" + value[1] + " per " + value[2];
      }
      if (Array.isArray(value)) {
        return value.join("\n");
      }
      if (typeof value === "boolean") {
        return value ? "Yes" : "No";
      }
      return value;
    },
    getDisplayLabel(item) {
      let result = item.label;
      if (item[this.labelKey]) {
        result = item[this.labelKey];
      }
      result = result.trim();
      if (result && result.length > 0) {
        if (result[result.length - 1] === "*") {
          result = result.substring(0, result.length - 1).trim();
        }
      }
      return result;
    }
  }
};
</script>

<style scoped>
.detail-info {
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/common/DetailSectionRowLayout.vue